import React from "react";
import { useGetWorkflowServiceQuery, WorkflowService } from "../../../../__generated__/api";
import SettingsContainer from "../../../../components/theme/settings";
import { useSetTitle } from "../base";
import Styles from "./Services.module.scss";
import ViewServiceCard from "./ViewServiceCard";
import Avatar from "../../../../components/avatar/Avatar";
import Text from "../../../../components/theme/text/Text";
import { tryParseDate } from "../../../../date";
import Badge from "../../../../components/theme/badge/Badge";
import Icon from "../../../../components/theme/icon/Icon";
import RouterLink from "../../../../components/theme/button/RouterLink";
import { Paths } from "../../../../contexts/Routing";
import { HelpContext } from "../../../../contexts/HelpContext";
import Help, { ARTICLES } from "../../../../components/help/Help";
import Button from "../../../../components/theme/button/Button";
import useServiceInstall from "./ServiceInstall";

export default function ListIntegrations({
    id,
}: {
    id: string;
}) {
    // service.installedIntegrations
    const { data, loading: isLoading } = useGetWorkflowServiceQuery({
        variables: {
            id,
        },
    });

    useSetTitle(data?.workflowService?.name, [data?.workflowService]);

    const { element: installElement, onInstall } = useServiceInstall();
    return (
        <SettingsContainer
            navigation="tabs"
            navigationButtons={(
                <>
                    <Help
                        articleId={ARTICLES.SETTINGS_INSTLLING_HOW_TO}
                        buttonType="small-icon"
                        button="How to Install"
                        buttonVariant="ghost-blue"
                    />
                    <Button.Add
                        size="small"
                        variant="primary"
                        onClick={() => onInstall(data?.workflowService as WorkflowService)}
                    >
                        Install
                        {" "}
                        {data?.workflowService?.name}
                    </Button.Add>
                </>
            )}
        >
            {installElement}

            <SettingsContainer.Section
                title="Connections"
                counter={(data?.workflowService?.installedIntegrations?.length ?? 0).toString()}
                shouldDisplayTitle={false}
                className={Styles.services}
            >
                <SettingsContainer.Setting
                    title="Connections"
                    description="The list of installed services"
                    permissions={SettingsContainer.Setting.Permissions.Administrator}
                    isHideTitle
                    isLoading={isLoading}
                    isFullWidth
                >
                    <div className={Styles["integration-cards"]}>
                        {data?.workflowService?.installedIntegrations?.map(integration => (
                            <div className={Styles["integration-card"]} key={integration.id}>
                                <Avatar
                                    isCircle={false}
                                    variant="sm-3"
                                    src={data?.workflowService?.squareIconUrl as string}
                                    className={Styles["workflow-card-icon"]}
                                    shouldShowLoading={false}
                                />
                                <div className={Styles["integration-title"]}>
                                    <Text textVariant="subtitle-3">{integration.label}</Text>
                                    <Text
                                        textVariant="body-2-regular"
                                        colorVariant="body-secondary"
                                    >
                                        {integration.connectionUrl ? new URL(integration.connectionUrl).hostname : ""}
                                    </Text>
                                </div>
                                <div>
                                    <Text textVariant="body-2-regular" colorVariant="body-secondary">Connected</Text>
                                    <Text textVariant="body-2-regular">
                                        {tryParseDate(integration.createdDate)?.toLocaleDateString(undefined, {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric",
                                        })}
                                    </Text>
                                </div>
                                <div>
                                    <Text textVariant="body-2-regular" colorVariant="body-secondary">Status</Text>
                                    <Badge variant="success" prefixIcon={<Icon.Circle size="small" />}>
                                        Active
                                    </Badge>
                                </div>
                                <RouterLink
                                    variant="outline-blue"
                                    to={Paths.ADMINISTRATOR_SETTING_ID_CHILD}
                                    params={{ setting: "workflow-service", id, childId: integration.id as string }}
                                >
                                    Details
                                </RouterLink>

                            </div>
                        ))}
                    </div>

                </SettingsContainer.Setting>
            </SettingsContainer.Section>
            <SettingsContainer.Section title="About" shouldDisplayTitle={false} className={Styles.services}>
                <SettingsContainer.Setting
                    title="Installed Services"
                    description="The installed set of services"
                    permissions={SettingsContainer.Setting.Permissions.Administrator}
                    isHideTitle
                    isLoading={isLoading}
                >
                    <ViewServiceCard isFullPage service={data?.workflowService as WorkflowService} isLoading={isLoading} />
                </SettingsContainer.Setting>
            </SettingsContainer.Section>
        </SettingsContainer>
    );
}
